module.exports = require("/home/travis/build/gladly-team/tab-homepage/src/themes/typography")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 1133
// module chunks = 231608221292675